<template>
  <div class="filter-categories-2">
    <categories-wrapper>
      <template v-slot="{categories}">


        <swiper id="filter-categories-2-slider" class="mySwiper w-100 px-5"
                v-bind="swiperOptions" :navigation="true" :modules="modules">

          <template v-for="category in categories" :key="category.id">
            <swiper-slide v-if="category.products_count > 0">


              <div class="filter-category-2 text-center"
                   @click="setSelectedCategory(category)">
                <img :class="[category==selectedCategory ? 'filter-category-2-active':'']"
                     class="filter-category-2-image" :src="category.image" :alt="category.name">
                <span class="filter-category-2-title">{{ category.name }}</span>
              </div>


            </swiper-slide>
          </template>


        </swiper>

        <div class="category-children" v-if="selectedCategory != ''">
          <span class="mx-1 btn rounded-pill"
                @click="setCategoryChildren(category)"
                v-for="category in selectedCategory.children"
                :class="[category == selectedChildrenCategory ? 'btn-primary' :'btn-outline-primary']"
          >
            {{ category.name }}</span>
        </div>

      </template>
    </categories-wrapper>


  </div>
</template>

<script>

import CategoriesWrapper from "../../../Wrappers/CategoryWrapper.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import {EffectFade, Navigation} from "swiper";

export default {
  name: "FilterCategory2",
  components: {SwiperSlide, Swiper, CategoriesWrapper},
  data() {
    return {
      selectedCategory: '',
      selectedChildrenCategory: '',
      lastSelectedCategory: '',
      swiperOptions: {
        breakpoints: {
          300: {
            slidesPerView: 2,
            spaceBetween: 70,
          },
          400: {
            slidesPerView: 3,
            spaceBetween: 70,
          },
          430: {
            slidesPerView: 3,
            spaceBetween: 50,
          },
          490: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
          520: {
            slidesPerView: 4,
            spaceBetween: 50,
          },
          768: {
            slidesPerView: 6,
            spaceBetween: 50,
          },
          980: {
            slidesPerView: 8,
            spaceBetween: 50,
          },
          1200: {
            slidesPerView: 9,
            spaceBetween: 50,
          },
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    }
  },
  setup() {
    return {
      modules: [Navigation, EffectFade],
    };
  },
  methods: {
    setSelectedCategory(category) {
      this.selectedCategory = category
      this.lastSelectedCategory = category
    },
    setCategoryChildren(category) {
      this.selectedChildrenCategory = category
      this.lastSelectedCategory = category
    }
  },
  watch: {
    lastSelectedCategory: {
      handler(newValue, oldValue) {
        this.$emit('selectedCategory', {category: this.lastSelectedCategory})
      },
      deep: true
    },
  }
}
</script>

<style scoped>
.filter-category-2-image {
  width: 70px;
  height: 70px;
  object-fit: contain;
  display: block;
  border-radius: 5px;
  text-align: center;
  margin: auto;
}

.filter-category-2-active {
  border: 2px solid var(--primary);
}
</style>